module.exports = __webpack_public_path__ + "media/images/flags/32/Croatia-d8abef13718c18064f0b68b8ba3589e4.png";